// Which lists have arrived from the server, so pages can show skeletons first
const LOADS = {
  GET_ALL_INSURANCE: "insurance",
  GET_ALL_UNAPPROVED_INSURANCE: "unApproved",
  GET_ALL_APPROVED_INSURANCE: "approved",
  GET_CURRENT_INSURANCE: "renew",
  GET_MONTHLY_EXPIRES: "monthly",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (loaded = {}, action) => {
  const key = LOADS[action.type] || LOADS[action.failed];
  return key ? { ...loaded, [key]: true } : loaded;
};
